export const RESET_PASSWORD_AJAX_SUCCESS = "RESET_PASSWORD_AJAX_SUCCESS";